import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Form, Row, Col, Table, Menu, Modal, DatePicker, Select } from 'antd';
import { format } from 'date-fns';
import { Link } from 'react-router-dom';
import { Tag } from '../../../components/tags/tags';
import { PageHeader } from '../../../components/page-headers/page-headers';
import { Main, TableWrapper } from '../../styled';
import { Cards } from '../../../components/cards/frame/cards-frame';
import Heading from '../../../components/heading/heading';
import { UserTableStyleWrapper } from '../style';
import { payoutListing, exportPayout, partnerCoverageListing } from '../../../redux/manageRefererPayout/actionCreator';
import { BasicFormWrapper } from '../../styled';
import Spinner from '../../common/Spinner.js';
import { Button } from '../../../components/buttons/buttons';
import { AddUser } from '../style';
import moment from 'moment';
import mobilesearchicon from '../../../static/img/mobile_search_icon.svg';

import { listingList } from '../../../redux/manageListing/actionCreator';
import { hostListing } from '../../../redux/manageHost/actionCreator';

function RefererPayout() {
  const { backEndPrefix, dateFormat, perPageRecord, adminLoginRoleID, hostLoginRoleID } = global;
  const searchDateFormat = 'MM/DD/YYYY';
  const dispatch = useDispatch();

  const [form] = Form.useForm();

  const [pagination, setPagination] = useState({
    currentPage: 1,
    pageSize: perPageRecord,
    totalItems: 0,
  });
  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState('DESC');
  const [refererPayoutList, setRefererPayoutList] = useState([]);
  const [spinnerLoader, setSpinnerLoader] = useState(false);

  const [selectedFilters, setSelectedFilters] = useState([]);

  const [filterCheckInDate, setFilterCheckInDate] = useState(null);
  const [filterCheckInDateTo, setFilterCheckInDateTo] = useState(null);

  const [filterCheckOutDate, setFilterCheckOutDate] = useState(null);
  const [filterCheckOutDateTo, setFilterCheckOutDateTo] = useState(null);

  const [filterForm] = Form.useForm();

  const [loginUser, setLoginUser] = useState([]);

  const [filterListingSlug, setFilterListingSlug] = useState(null);
  const [filterHostSlug, setFilterHostSlug] = useState(null);
  const [listingDropdownList, setListingDropdownList] = useState([]);
  const [hostDropdownList, setHostDropdownList] = useState([]);
  const [gatewayFilter, setGatewayFilter] = useState(null);

  const fetchListingFilterData = async () => {
    try {
      const listingResponse = await dispatch(
        listingList({
          is_filter: 1, // fetch without pagination listing list
        }),
      );
      if (listingResponse) {
        setListingDropdownList(listingResponse);
      }
    } catch (error) { }
  };

  const fetchHostData = async () => {
    try {
      const response = await dispatch(hostListing({ is_filter: 1 }));

      if (response && response.status === 200 && Array.isArray(response.result)) {
        setHostDropdownList(response.result); // Correctly setting the host list from the result array
      } else {
        setHostDropdownList([]);
      }
    } catch (error) {
      setHostDropdownList([]);
    }
  };

  useEffect(() => {
    const getUser = JSON.parse(localStorage.getItem('user'));
    if(getUser){
      setLoginUser(getUser);
    }
  }, []);

  const fetchData = async () => {
    try {
      setSpinnerLoader(true);
      const response = await dispatch(
        payoutListing({
          page: pagination.currentPage,
          perPage: pagination.pageSize,
          sortField: sortField,
          sortOrder: sortOrder,
          checkin_date: filterCheckInDate,
          checkin_date_to: filterCheckInDateTo,
          checkout_date: filterCheckOutDate,
          checkout_date_to: filterCheckOutDateTo,
          listing_slug: filterListingSlug,
          host_slug: filterHostSlug,
          gateway: gatewayFilter,
        }),
      );

      if (response && response?.data) {
        setRefererPayoutList(response?.data);
        setPagination((prevState) => ({
          ...prevState,
          totalItems: response.total,
        }));
      }
      setSpinnerLoader(false);
    } catch (error) { }
  };
  useEffect(() => {
    fetchData();
  }, [
    pagination.currentPage,
    pagination.pageSize,
    sortField,
    sortOrder,
    filterCheckInDate,
    filterCheckOutDate,
    filterCheckInDateTo,
    filterCheckOutDateTo,
    filterListingSlug,
    filterHostSlug,
    gatewayFilter,
  ]);

  const refererPayoutTableData = [];
  refererPayoutList.map((refererPayoutdata) => {
    const { slug } = refererPayoutdata;
    return refererPayoutTableData.push({
      key: slug,
      listing_name: refererPayoutdata?.listing_name || '',
      listing_slug: refererPayoutdata?.listing_slug || '',
      booking_code: refererPayoutdata?.booking_code || '',
      host_referred_by: refererPayoutdata?.host_referred_by || '',
      referred_host_name: refererPayoutdata?.referred_host_name || '',
      checkin_date: refererPayoutdata?.checkin_date || '',
      checkout_date: refererPayoutdata?.checkout_date || '',
      payment_id: refererPayoutdata?.payment_id || '',
      payment_date: refererPayoutdata?.payment_date || '',
      amount: refererPayoutdata?.amount || '',
      gateway: refererPayoutdata?.gateway == 2 ? 'PayPal' : (refererPayoutdata?.gateway == 1 ? 'Stripe' : ''),
    });
  });

  const defineColumns = (role_id) => {
    const columns = [
      ...(role_id === 1
        ? [
        {
          title: <span>Listing <span className=''>Name</span></span>,
          dataIndex: 'listing_name',
          key: 'listing_name',
          sorter: true,
          width: 240
        },
        {
          title: <span>Listing <span className=''>Number</span></span>,
          dataIndex: 'listing_slug',
          key: 'listing_slug',
          sorter: true,
        },
        {
          title: <span>Booking <span className=''>Code</span></span>,
          dataIndex: 'booking_code',
          key: 'booking_code',
          sorter: true,
        },
      ]
        : []),
      {
        title: <span>Host <span className=''>Name</span></span>,
        dataIndex: 'host_referred_by',
        key: 'host_referred_by',
        sorter: true,
      },
      ...(role_id === 1
        ? [
            {
              title: <span>Referred <span className=''>By</span></span>,
              dataIndex: 'referred_host_name',
              key: 'referred_host_name',
              sorter: true,
            },
            {
              title: <span>Check In <span className=''>Date</span></span>,
              dataIndex: 'checkin_date',
              key: 'checkin_date',
              sorter: true,
            },
            {
              title: <span>Check Out <span className=''>Date</span></span>,
              dataIndex: 'checkout_date',
              key: 'checkout_date',
              sorter: true,
            },
          ]
        : []),
      {
        title: <span>Payment <span className=''>ID</span></span>,
        dataIndex: 'payment_id',
        key: 'payment_id',
        sorter: true,
      },
      {
        title: <span>Payment <span className=''>Date</span></span>,
        dataIndex: 'payment_date',
        key: 'payment_date',
        sorter: true,
      },
      {
        title: 'Amount',
        dataIndex: 'amount',
        key: 'amount',
        sorter: true,
      },
      ...(role_id === 1
        ? [
            {
              title: 'Gateway',
              dataIndex: 'gateway',
              key: 'gateway',
              sorter: false,
            },
          ]
        : []),
    ];
    return columns;
  };

  const refererPayoutTableColumns = defineColumns(loginUser.role_id);

  const handleSortChange = (pagination, filters, sorter) => {
    let sortOrder = 'DESC';
    if (sorter.order === 'descend') {
      sortOrder = 'ASC';
    }
    setSortField(sorter.field);
    setSortOrder(sortOrder);
  };

  const handlePaginationChange = (page, pageSize) => {
    setPagination({
      ...pagination,
      currentPage: page,
      pageSize,
    });
  };
  const handlePageSizeChange = (current, size) => {
    setPagination({
      ...pagination,
      currentPage: current,
      pageSize: size,
    });
  };

  const [state, setState] = useState({
    selectedRowKeys: 0,
    selectedRows: 0,
    visible: false,
    editVisible: false,
    modalType: 'primary',
    url: null,
    update: {},
  });
  const showSearchModel = () => {
    /* On Click Filter showing Data of the API  */
    const getUser = JSON.parse(localStorage.getItem('user'));
    if (getUser?.role_id === adminLoginRoleID) {
      fetchListingFilterData();
      fetchHostData();
    } else if (getUser?.role_id === hostLoginRoleID) {
      fetchListingFilterData();
    }
    /* On Click Filter showing Data of the API  */
    setState({
      ...state,
      visible: true,
      editVisible: false,
    });

    const filterWithListing = selectedFilters.find((filter) => filter.startsWith('Listing:'));
    const filterWithHost = selectedFilters.find((filter) => filter.startsWith('Referred By:'));

    filterForm.resetFields();
    const fieldsValue = {};
    if (selectedFilters.find((filter) => filter.startsWith('Check-in Date From:'))?.split(':')[1]) {
      fieldsValue.checkin_date = moment(
        selectedFilters.find((filter) => filter.startsWith('Check-in Date From:'))?.split(':')[1],
        'MM/DD/YYYY',
      );
    }
    if (selectedFilters.find((filter) => filter.startsWith('Check-in Date To:'))?.split(':')[1]) {
      fieldsValue.checkin_date_to = moment(
        selectedFilters.find((filter) => filter.startsWith('Check-in Date To:'))?.split(':')[1],
        'MM/DD/YYYY',
      );
    }
    if (selectedFilters.find((filter) => filter.startsWith('Check-out Date From:'))?.split(':')[1]) {
      fieldsValue.checkout_date = moment(
        selectedFilters.find((filter) => filter.startsWith('Check-out Date From:'))?.split(':')[1],
        'MM/DD/YYYY',
      );
    }
    if (selectedFilters.find((filter) => filter.startsWith('Check-out Date To:'))?.split(':')[1]) {
      fieldsValue.checkout_date_to = moment(
        selectedFilters.find((filter) => filter.startsWith('Check-out Date To:'))?.split(':')[1],
        'MM/DD/YYYY',
      );
    }
    if (filterWithListing) {
      fieldsValue.listing_slug = filterListingSlug;
    }
    if (filterWithHost) {
      fieldsValue.host_slug = filterHostSlug;
    }
    if (gatewayFilter) {
      fieldsValue.gateway = gatewayFilter;
    }
    filterForm.setFieldsValue(fieldsValue);
  };

  const [statedate, setdatestate] = useState({
    date: null,
    dateString: null,
  });

  const onChange = (date, dateString) => {
    setdatestate({ ...statedate, date, dateString });
  };

  const [initialFilterValues, setInitialFilterValues] = useState({});
  const handleCancel = () => {
    onCancel();
  };
  //on cancel hide popup
  const onCancel = () => {
    setState({
      ...state,
      visible: false,
      editVisible: false,
    });
  };

  const handleFilterRemove = (filterToRemove) => {
    setPagination({
      currentPage: 1,
      pageSize: perPageRecord,
    });
    setSelectedFilters(filterToRemove);
    if (filterToRemove.length > 0) {
      const filterWithCheckInDate = filterToRemove.find((filter) => filter.startsWith('Check-in Date From:'));
      const filterWithCheckInDateTo = filterToRemove.find((filter) => filter.startsWith('Check-in Date To:'));

      const filterWithCheckoutDate = filterToRemove.find((filter) => filter.startsWith('Check-out Date From:'));
      const filterWithCheckoutDateTo = filterToRemove.find((filter) => filter.startsWith('Check-out Date To:'));

      const filterWithListing = filterToRemove.find((filter) => filter.startsWith('Listing:'));
      const filterWithHost = filterToRemove.find((filter) => filter.startsWith('Referred By:'));

      setFilterCheckInDate(filterWithCheckInDate ? filterCheckInDate : null);
      setFilterCheckInDateTo(filterWithCheckInDateTo ? filterCheckInDateTo : null);

      setFilterCheckOutDate(filterWithCheckoutDate ? filterCheckOutDate : null);
      setFilterCheckOutDateTo(filterWithCheckoutDateTo ? filterCheckOutDateTo : null);

      setFilterListingSlug(filterWithListing ? filterListingSlug : null);
      setFilterHostSlug(filterWithHost ? filterHostSlug : null);
      const filterWithGateway = filterToRemove.find((filter) => filter.startsWith('Gateway:'));
      setGatewayFilter(filterWithGateway ? gatewayFilter : null);
    } else {
      setFilterCheckInDate(null);
      setFilterCheckInDateTo(null);
      setFilterCheckOutDate(null);
      setFilterCheckOutDateTo(null);

      setFilterListingSlug(null);
      setFilterHostSlug(null);
      setGatewayFilter(null);
    }
  };

  const onSubmitSearch = (values) => {
    onCancel();
    // const partnerCoverageData = partnerCoverageDropdown.find((coveragePartner) => coveragePartner.slug === values.slug);
    const dropdownListData = listingDropdownList.find((listing) => listing.slug === values.listing_slug);
    const dropdownHostData = hostDropdownList.find((host) => host.slug === values.host_slug);

    const checkinDate = values.checkin_date ? values.checkin_date.format(searchDateFormat) : null;
    const checkinDateTo = values.checkin_date_to ? values.checkin_date_to.format(searchDateFormat) : null;

    const checkoutDate = values.checkout_date ? values.checkout_date.format(searchDateFormat) : null;
    const checkoutDateTo = values.checkout_date_to ? values.checkout_date_to.format(searchDateFormat) : null;

    const selectedFilterData = [];
    if (checkinDate) {
      selectedFilterData.push(`Check-in Date From: ${checkinDate}`);
    }
    if (checkinDateTo) {
      selectedFilterData.push(`Check-in Date To: ${checkinDateTo}`);
    }

    if (checkoutDate) {
      selectedFilterData.push(`Check-out Date From: ${checkoutDate}`);
    }
    if (checkoutDateTo) {
      selectedFilterData.push(`Check-out Date To: ${checkoutDateTo}`);
    }
    if (values.listing_slug) {
      selectedFilterData.push(`Listing: ${dropdownListData.listing_name}`);
    }
    if (values.host_slug) {
      selectedFilterData.push(`Referred By: ${dropdownHostData.name}`);
    }
    const selectedGateway = values.gateway ?? null;
    if (selectedGateway) {
      const gatewayLabel = selectedGateway == 2 ? 'PayPal' : 'Stripe';
      selectedFilterData.push(`Gateway: ${gatewayLabel}`);
    }
    setGatewayFilter(selectedGateway);
    setSelectedFilters(selectedFilterData);

    setFilterCheckInDate(checkinDate);
    setFilterCheckInDateTo(checkinDateTo);

    setFilterCheckOutDate(checkoutDate);
    setFilterCheckOutDateTo(checkoutDateTo);

    setFilterListingSlug(values.listing_slug);
    setFilterHostSlug(values.host_slug);

    form.resetFields();
    setPagination({
      currentPage: 1,
      pageSize: perPageRecord,
    });
  };

  const exportPayoutFunction = async () => {
    try {
      setSpinnerLoader(true);
      const exportResponse = await dispatch(
        exportPayout({
          checkin_date: filterCheckInDate,
          checkin_date_to: filterCheckInDateTo,
          checkout_date: filterCheckOutDate,
          checkout_date_to: filterCheckOutDateTo,
          is_export: 1,
          sortField: sortField,
          sortOrder: sortOrder,
          listing_slug: filterListingSlug,
          host_slug: filterHostSlug,
          gateway: gatewayFilter,
        }),
      );
      if (exportResponse) {
        const url = window.URL.createObjectURL(new Blob([exportResponse.data]));
        const link = document.createElement('a');
        link.href = url;
        const currentDateTime = moment(new Date()).format('MM-DD-YY-HH-mm-ss');
        link.setAttribute('download', `Referral-Report-${currentDateTime}.csv`);
        document.body.appendChild(link);
        link.click();
      }
      setSpinnerLoader(false);
    } catch (error) { }
  };
  return (
    <>
      <Main className="mainBlock">      
        <div className="top_header_sticky">
          <Row gutter={15} className="mb-0">
            <Col xs={24}>
              <div className="d-flex pageheader justify-content-end">
                <PageHeader
                  className="pageheaderButton mobile_view_hide"
                  ghost
                  buttons={[
                    // Check if the user has role_id 1 and has the 'referral-report-index' permission
                    loginUser.role_id === 1 && global.checkPermission('referral-report-index') && (
                      <Button className="mobile_view_hide_btn" onClick={showSearchModel} size="default" shape="circle" type="primary" key="1">
                        Search
                      </Button>
                    ),
                    
                    // Check if the user has 'referral-report-index' permission for the Export button
                    global.checkPermission('referral-report-index') && (
                      <Button onClick={() => exportPayoutFunction()} shape="circle" outlined type="primary" key="3">
                        Export CSV
                      </Button>
                    ),
                  ]}
                  
                />
              </div>
              <div className="global_search_filter">
                {selectedFilters.length > 0 && (
                  <Tag key={selectedFilters} animate data={selectedFilters} onChange={handleFilterRemove} />
                )}
              </div>
            </Col>
          </Row>
        </div>
        <Row gutter={15}>
          <Col xs={24}>
            <Spinner loader={spinnerLoader} />
            <Cards
              headless
              className='borderRadius common_fiter_table'
            >
              <UserTableStyleWrapper>
                <div className="contact-table">
                  <TableWrapper className="table-responsive">
                    <Table
                      // rowSelection={rowSelection}
                      dataSource={refererPayoutTableData}
                      columns={refererPayoutTableColumns}
                      onChange={handleSortChange}
                      rowKey="slug"
                      pagination={{
                        current: pagination.currentPage,
                        pageSize: pagination.pageSize,
                        total: pagination.totalItems,
                        showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                        onChange: handlePaginationChange,
                        onShowSizeChange: handlePageSizeChange,
                      }}
                    />
                  </TableWrapper>
                </div>
              </UserTableStyleWrapper>
            </Cards>
          </Col>
        </Row>
      </Main>

      <Modal
        type={state.modalType}
        centered
        open={state.visible}
        title="Search Filter"
        footer={null}
        onCancel={handleCancel}
        className="modal-md"
        key={1}
        maskClosable={false}
        aria-hidden="false"
      >
        <div className="project-modal">
          <AddUser>
            <BasicFormWrapper>
              <Form form={filterForm} name="contact" onFinish={onSubmitSearch} initialValues={initialFilterValues}>
                <Row gutter={15}>
                      
                  {loginUser.role_id === 1 && (
                    <>
                    <Col xs={24} md={24}>
                        <div className="project-modal">
                          <Form.Item label="Select Listing" name="listing_slug" className="custom_input_style">
                            <Select
                              size="large"
                              className="ninjadash-fullwidth-select"
                              placeholder="Select Listing"
                              showSearch
                              filterOption={(input, option) => {
                                const children = option.props.children;
                                if (typeof children === 'string') {
                                  return children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                                } else if (Array.isArray(children)) {
                                  const concatenatedString = children.join('');
                                  return concatenatedString.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                                }
                                return false;
                              }}
                              allowClear
                            >
                              {listingDropdownList.map((value, index) => (
                                <option key={index} value={value.slug}>
                                  {value.listing_name} ({value.slug})
                                </option>
                              ))}
                            </Select>
                          </Form.Item>
                        </div>
                      </Col>
                      <Col xs={24} md={24}>
                        <div className="project-modal">
                          <Form.Item label="Select Referred By" name="host_slug" className="custom_input_style">
                            <Select
                              size="large"
                              className="ninjadash-fullwidth-select"
                              placeholder="Select Referred By"
                              showSearch
                              filterOption={(input, option) => {
                                const children = option.props.children;
                                if (typeof children === 'string') {
                                  return children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                                } else if (Array.isArray(children)) {
                                  const concatenatedString = children.join('');
                                  return concatenatedString.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                                }
                                return false;
                              }}
                              allowClear
                            >
                              {hostDropdownList.map((value, index) => (
                                <option key={index} value={value.slug}>
                                  {value.name}
                                </option>
                              ))}
                            </Select>
                          </Form.Item>
                        </div>
                      </Col>
                      <Col xs={24} md={24}>
                        <div className="project-modal">
                          <Form.Item label="Gateway" name="gateway" className="custom_input_style">
                            <Select
                              size="large"
                              className="ninjadash-fullwidth-select"
                              placeholder="Select gateway"
                              allowClear
                            >
                              <Select.Option value={1}>Stripe</Select.Option>
                              <Select.Option value={2}>PayPal</Select.Option>
                            </Select>
                          </Form.Item>
                        </div>
                      </Col>
                    </>
                  )}

                  <Col xs={24} md={24}>
                    <div className="project-modal">
                      <Form.Item label="Check In Date From" name="checkin_date">
                        <DatePicker
                          onChange={onChange}
                          format={searchDateFormat}
                          className="date_time_pcikr"
                          placeholder="Select check in date from"
                        />
                      </Form.Item>
                    </div>
                  </Col>
                  <Col xs={24} md={24} >
                    <div className="project-modal">
                      <Form.Item label="Check In Date To" name="checkin_date_to">
                        <DatePicker onChange={onChange} format={searchDateFormat} className='date_time_pcikr' placeholder='Select check in date to' />
                      </Form.Item>
                    </div>
                  </Col>
                  <Col xs={24} md={24}>
                    <div className="project-modal">
                      <Form.Item label="Check Out Date From" name="checkout_date">
                        <DatePicker
                          onChange={onChange}
                          format={searchDateFormat}
                          className="date_time_pcikr"
                          placeholder="Select check out date from"
                        />
                      </Form.Item>
                    </div>
                  </Col>
                  <Col xs={24} md={24} >
                    <div className="project-modal">
                      <Form.Item label="Check Out Date To" name="checkout_date_to">
                        <DatePicker onChange={onChange} format={searchDateFormat} className='date_time_pcikr' placeholder='Select check out date to' />
                      </Form.Item>
                    </div>
                  </Col>
                </Row>
                <Row gutter={15} className="mt-20">
                  <Col xs={24}>
                    <Button htmlType="submit" size="default" type="dark" shape="circle" key="submit" className="w-100">
                      Find
                    </Button>
                  </Col>
                </Row>
              </Form>
            </BasicFormWrapper>
          </AddUser>
        </div>
      </Modal>
      <div className="mobile_view_serach">
        <a onClick={showSearchModel} type="button">
          <img src={mobilesearchicon} alt="Search-Icon" />
        </a>
      </div>
    </>
  );
}

export default RefererPayout;
